import { render, staticRenderFns } from "./MarkRecogSidebar.vue?vue&type=template&id=9c032af0&scoped=true&"
import script from "./MarkRecogSidebar.vue?vue&type=script&lang=ts&"
export * from "./MarkRecogSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./MarkRecogSidebar.vue?vue&type=style&index=0&id=9c032af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c032af0",
  null
  
)

export default component.exports